// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__wWICh","ativo":"Chip_ativo__nKMqA","clicavel":"Chip_clicavel__Oy7qs","remover":"Chip_remover__YiDu4"};